import { useIntl } from 'react-intl'
import {
  badgeSizeOptions,
  badgesVariantOptions
} from '../../../../../components/stories/atoms/badges/constants'
import { handleRoleColor } from '../../../../../components/copy-project-modal/constants'
import BadgesComponent from '../../../../../components/stories/atoms/badges'
import PropTypes from 'prop-types'

const ProjectMenuMbileBadgeRole = ({ item = null }) => {
  const { formatMessage } = useIntl()

  const roleType = item?.role?.type
  const roleName = item?.role?.name
  const roleLabel = roleType
    ? formatMessage({
        id: `personas_roleLabel${roleType}`,
        defaultMessage: roleName ?? roleType
      })
    : (roleName ?? '')

  if (!item) return null

  return (
    <BadgesComponent
      variant={badgesVariantOptions.STRONG}
      size={badgeSizeOptions.SMALL}
      color={handleRoleColor(roleType)}
    >
      {roleLabel}
    </BadgesComponent>
  )
}

ProjectMenuMbileBadgeRole.propTypes = {
  item: PropTypes.object
}

export default ProjectMenuMbileBadgeRole
